/* unplugin-vue-components disabled */import { render } from "./MyCalendar.vue?vue&type=template&id=0f94fcd9&scoped=true"
import script from "./MyCalendar.vue?vue&type=script&lang=js"
export * from "./MyCalendar.vue?vue&type=script&lang=js"

import "./MyCalendar.vue?vue&type=style&index=0&id=0f94fcd9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f94fcd9"]])

export default __exports__